/**
 * Two columns side by side on a wide screen, one above the other on a narrow
 * one — how a detail screen sets its panels out.
 *
 * `minmax(0, …)` rather than a bare `fr`, so a long word or a wide table in one
 * column shrinks inside it instead of pushing the other column off the screen.
 */
import type { ReactNode } from 'react';
import Box from '@mui/material/Box';

export interface ColumnsProps {
  /** The two widths, as shares: `[2, 1]` gives the first twice the second. Default `[1, 1]`. */
  split?: readonly [number, number];
  /** From which screen size the two sit side by side. Default `md`. */
  from?: 'md' | 'lg';
  /** `start` keeps each column as tall as its content; `stretch` makes both equal. Default `stretch`. */
  align?: 'start' | 'stretch';
  children: ReactNode;
}

export function Columns({ split = [1, 1], from = 'md', align = 'stretch', children }: ColumnsProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 3,
        alignItems: align,
        gridTemplateColumns: { xs: '1fr', [from]: `minmax(0, ${split[0]}fr) minmax(0, ${split[1]}fr)` },
      }}
    >
      {children}
    </Box>
  );
}
